import useRole from '@/hooks/useRole';
import { RuleName } from '@/types';
import CompanyInfo from './CompanyInfo';
import PersonalInfo from './PersonalInfo';

const PersonalCompanyInfo = () => {
  const { hasRole } = useRole();
  const isOwner = hasRole(RuleName.OWNER);

  return (
    <>
      <PersonalInfo />
      <CompanyInfo disabled={!isOwner} />
    </>
  );
};

export default PersonalCompanyInfo;
